import type { ReactNode } from 'react';
import { Button } from './Button';

export function Banner({ children, onDismiss }: { children: ReactNode; onDismiss?: () => void }) {
  return (
    <div
      role="status"
      className="mb-3 flex items-start gap-2 rounded-2xl border border-border bg-surface-2 p-3 text-sm"
    >
      <div className="flex-1">{children}</div>
      {onDismiss ? (
        <Button variant="ghost" onClick={onDismiss} className="px-3">
          Dismiss
        </Button>
      ) : null}
    </div>
  );
}
